import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `industry`);
        return response;
    } catch (e) { }
}

export async function add(name: any, dstiEnabled: boolean) {
    try {
        const response = await apiPost('core', `industry`, { name: name, dsti_enabled: dstiEnabled });
        return response;
    } catch (e) { }
}

export async function update(newDetails: any) {
    try {
        const response = await apiPut('core', `industry/${newDetails.id}`, { name: newDetails.name, dsti_enabled: newDetails.dsti_enabled });
        return response;
    } catch (e) { }
}

export async function removeIndustry(id: any) {
    try {
        return await apiDelete('core', `industry/${id}`);
    } catch (e) { }
}